var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',[_c('b-table',{attrs:{"id":"table","striped":"","hover":"","items":_vm.rowsShow,"fields":_vm.fields},scopedSlots:_vm._u([{key:"cell()",fn:function(data){return [_c('b-link',{staticClass:"mr-4",attrs:{"target":"_blank","to":{ name: 'Source', params: {id: data.item.id}}}},[_vm._v(_vm._s(data.value))])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }